const LogOut = () => {
    return (
        <div>
            <p>This is Log Out page</p>
        </div>
    )
}

export default LogOut